import React, { useCallback, useEffect, useState } from "react";

import { ChevronLeft } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  IconButton,
  TablePagination,
  Typography,
} from "@mui/material";
import { connect, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import InterviewResultsCandidatesTable from "../../components/InterviewResults/InterviewResultsCandidatesTable";
import InterviewResultsCandidatesTableHeader from "../../components/InterviewResults/InterviewResultsCandidatesTableHeader";

import {
  getSingleInterivew as getSingleInterivewAction,
  getAllInterivews as getAllInterivewsAction,
} from "../../redux/slices/interviewSlice";
import { selectAssessmentById } from "../../redux/slices/myAssessmentsSlice";
import {
  getSinglePost as getSinglePostAction,
  selectPostById,
} from "../../redux/slices/postsSlice";
import InviteViaAssessmentModal from "../../components/Modals/InviteViaAssessmentModal";
import InviteCandidatesModal from "../../components/Modals/InviteCandidatesModal";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
/* ============================================================================
<InterviewResultsCandidates />
============================================================================= */
const InterviewResultsCandidates = ({
  interviewData,
  totalInterivews,
  getSinglePost,
  getAllInterivews,
}) => {
  const { id, id_type } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [query, setQuery] = useState("");
  const [rowsPerPage, setRowPerPage] = useState(10);
  const [filters, setFilters] = useState({});
  const [inivteModal, setInviteModal] = useState(false);
  const [interviewValue, setInterviewValue] = useState(77);
  const [passingCriteriaSet, setPassingCriteriaSet] = useState(false);
  const [tabValue, setTabValue] = useState("share_link");
  const [copied, setCopied] = useState(false);
  const [linkGenerated, setLinkGenerated] = useState(false);
  const [interviewId, setInterviewId] = useState("");
  const [selectedAssessmentId, setSelectedAssessmentId] = useState(id);
  const [files, setFiles] = useState([]);
  const [CsvTableData, setCsvTableData] = useState();

  const entitiy = useSelector((state) =>
    id_type === "post"
      ? selectPostById(state, id)
      : selectAssessmentById(state, id)
  );
  console.log(entitiy, id_type);

  useEffect(() => {
    if (!entitiy && id_type === "post") getSinglePost(id);
    _getTableData(page, query, filters);
  }, [page]);

  useEffect(() => {
    if (interviewData[page]) {
      setTableData(interviewData[page]);
    }
  }, [interviewData]);

  const _getTableData = useCallback(
    async (_page, _query, _filters, take) => {
      setIsLoading(true);
      const payload = { page: _page, query: _query, filters: _filters };

      if (id_type === "post") payload.job_id = id;
      if (id_type === "assessment") payload.assessment_id = id;
      if (take) payload.take = take;

      await getAllInterivews(payload);
      setIsLoading(false);
    },
    [page, query, filters, id_type, isLoading]
  );

  const onSearch = useCallback(
    (searchQuery) => {
      setPage(1);
      setQuery(searchQuery);
      _getTableData(1, searchQuery, filters);
    },
    [query, page, filters]
  );

  const onFilterChange = useCallback(
    (_filters) => {
      const newFilters = { ...filters, ..._filters };
      setPage(1);
      setFilters(newFilters);
      _getTableData(1, query, newFilters);
    },
    [page, filters]
  );

  const onRefresh = () => _getTableData(page, query, filters);

  const onReset = () => {
    const resetFilters = {};
    setFilters(resetFilters);
    _getTableData(page, query, resetFilters);
  };

  const _handleRowsPerPageChange = (event) => {
    setPage(1);
    setRowPerPage(parseInt(event.target.value, 10));
    _getTableData(1, query, filters, parseInt(event.target.value, 10));
  };

  const handleClose = () => {
    setInviteModal(false);
    setInterviewId("");
    setLinkGenerated(false);
    setPassingCriteriaSet(false);
    setTabValue("share_link");
    setInterviewValue(77);
    setFiles([]);
    setCsvTableData([]);
  };

  return (
    <>
      <Sidebar />
      <Navbar />
      <Card sx={{ height: "100%", ml: { xs: 0, md: "220px" } }}>
        <Box
          display="flex"
          p={2}
          borderBottom="1px solid #d1d1d1"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
        >
          <Box display="flex" alignItems="center" gap={2}>
            <IconButton
              size="small"
              sx={{ border: "1px solid #B1B1B1" }}
              onClick={() => navigate(-1)}
            >
              <ChevronLeft sx={{ fontSize: 18, color: "#B1B1B1" }} />
            </IconButton>
            <Typography
              fontSize={{ xs: "14px", md: "18px" }}
              fontWeight={600}
              color="#48555E"
            >
              {entitiy
                ? id_type === "assessment"
                  ? entitiy?.assessment_name
                  : entitiy?.job_name
                : "--"}
            </Typography>
          </Box>
          <Box display="flex" gap={1}>
            {/* <Button
            variant="main"
            onClick={() => setInviteModal(true)}
            sx={{
              fontSize: 14,
              fontWeight: 500,
              fontFamily: "Outfit",
              borderRadius: { xs: "5px", md: "30px" },
            }}
          >
            Invite +
          </Button> */}
          </Box>
        </Box>
        <Box p={2} height="100%">
          <InterviewResultsCandidatesTableHeader
            onSearch={onSearch}
            filters={filters}
            onReload={onRefresh}
            onReset={onReset}
            tableDataLength={tableData?.length}
            onFilterChange={onFilterChange}
          />
          <InterviewResultsCandidatesTable
            isLoading={isLoading}
            page={page}
            setPage={setPage}
            getData={onRefresh}
            tableData={tableData}
          />
          {tableData?.length > 0 && (
            <TablePagination
              component="div"
              count={totalInterivews}
              page={page - 1}
              onPageChange={(_, newPage) => setPage(newPage + 1)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={_handleRowsPerPageChange}
              sx={{
                fontFamily: "Outfit",
                "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                  {
                    fontFamily: "Outfit",
                  },
                "& .MuiInputBase-root": {
                  fontFamily: "Outfit",
                },
              }}
            />
          )}
        </Box>

        <InviteViaAssessmentModal
          open={inivteModal}
          onClose={() => handleClose()}
          interviewValue={interviewValue}
          setInterviewValue={setInterviewValue}
          passingCriteriaSet={passingCriteriaSet}
          setPassingCriteriaSet={setPassingCriteriaSet}
          tabValue={tabValue}
          setTabValue={setTabValue}
          selectedAssessmentId={selectedAssessmentId}
          copied={copied}
          setCopied={setCopied}
          linkGenerated={linkGenerated}
          setLinkGenerated={setLinkGenerated}
          interviewId={interviewId}
          setInterviewId={setInterviewId}
          flag={true}
          setFiles={setFiles}
          files={files}
          CsvTableData={CsvTableData}
          setCsvTableData={setCsvTableData}
        />
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  totalInterivews: state.interview.totalInterivews,
  interviewData: state.interview.interviewData,
});

const mapDipatchToProps = {
  getSinglePost: getSinglePostAction,
  getSingleInterivew: getSingleInterivewAction,
  getAllInterivews: getAllInterivewsAction,
};

/* Export
============================================================================= */
export default connect(
  mapStateToProps,
  mapDipatchToProps
)(InterviewResultsCandidates);
